import Logger from '../lib/Logger';
export const setupApplicationLogger = () => {
  return window.LOG = Logger.getLogger('applicationLogger');
};